import maplibregl from "maplibre-gl";

export default {
    computed: {
        defaultConfigMaplibre() {
            return {
                container: 'map',
                style: 'https://tile.openstreetmap.jp/styles/osm-bright/style.json',
                zoom: this.zoomLevel,
                center: this.coordinates,
                dragPan: this.dragPan,
                pitch: this.pitch,
                maxBounds: this.bounds,
                bearing: this.bearing,
                minZoom: this.minZoom,
                maxZoom: this.maxZoom,
                cooperativeGestures: this.cooperativeGestures,
                touchPitch: false
            }
        }
    },
    methods: {
        loadMaplibre() {
            this.mySmartMap = this.mySmartMap ? this.mySmartMap : new maplibregl.Map(this.defaultConfigMaplibre)
            this.handleLocateUserMaplibre();
            if (this.useMaplibre) {
                this.handleCompassMaplibre();
            }
        },
        handleLocateUserMaplibre() {
            if (!this.geolocateControl) {
                this.geolocateControl = new maplibregl.GeolocateControl({
                    positionOptions: {
                        enableHighAccuracy: true
                    },
                    trackUserLocation: true
                })
            }
            if (this.applyLocateUser) {
                this.mySmartMap.addControl(this.geolocateControl)
            } else if (this.mySmartMap.hasControl(this.geolocateControl)) {
                this.mySmartMap.removeControl(this.geolocateControl)
            }
        },
        handleCompassMaplibre() {
            const navigationControlMaplibre = new maplibregl.NavigationControl({
                showCompass: true,
                showZoom: false
            });
            this.mySmartMap.addControl(navigationControlMaplibre, 'bottom-right');
        },
        loadTileLayerMaplibre() {
            if (!this.currentLayer.tile_layer) {
                return;
            }

            var self = this;
            this.mySmartMap.on('load', () => {
                self.mySmartMap.addSource('tile-layer-source-parcel', {
                    'type': 'raster',
                    'tiles': [self.currentLayer.tile_layer],
                    'tileSize': 256
                });
                self.mySmartMap.addLayer(
                    {
                        'id': 'tile-layer-source-parcel',
                        'type': 'raster',
                        'source': 'tile-layer-source-parcel',
                        'paint': {}
                    }
                );
            });
        },
    },
    mounted() {
        this.loadMaplibre();
        this.loadTileLayerMaplibre();
    },
}